import './App.css';
import { createBrowserRouter, RouterProvider, Outlet, useLocation } from 'react-router';
import { useEffect } from 'react';
import { NavBar } from "./components/NavBar";
import { Banner } from './components/Banner';
import { AboutMe } from './components/AboutMe';
import { Projects } from './components/Projects';
import { ProjectDetails } from './components/ProjectDetails';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import 'bootstrap/dist/css/bootstrap.min.css';


const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const scrollTo = sessionStorage.getItem('scrollTo');

    if (scrollTo) {
        document.getElementById(scrollTo)?.scrollIntoView({
          behavior: 'instant',
          block: 'center'
        });
    } else {
      window.scrollTo({ top: 0, behavior: 'instant' });
    }
  }, [pathname]);

  return null;
};

const AppLayout = () => (
  <>
    <NavBar />
    <ScrollToTop />
    <Outlet />
    <Footer />
  </>
);

const router = createBrowserRouter([
  {
    path: "/",
    element: <AppLayout />,
    children: [
      {
        index: true,
        element: (
          <>
            <Banner />
            <AboutMe />
            <Projects />
            <Contact />
          </>
        )
      },
      {
        path: "/proyecto/:title",
        element: <ProjectDetails />
      }
    ]
  }
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;